var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 1.73206C17.3367 2.02476 16.6251 2.22348 15.8786 2.3121C16.6412 1.85559 17.2266 1.13054 17.5005 0.268536C16.7862 0.692824 15.9967 0.998956 15.1562 1.16545C14.4822 0.448456 13.5235 0 12.4601 0C10.4219 0 8.76772 1.65418 8.76772 3.69238C8.76772 3.9824 8.79994 4.26436 8.86439 4.5329C5.79502 4.37983 3.07474 2.90825 1.25407 0.674026C0.937192 1.21916 0.754588 1.8529 0.754588 2.52961C0.754588 3.81053 1.40713 4.94107 2.39803 5.60167C1.79382 5.58287 1.22453 5.41638 0.725048 5.13979C0.725048 5.1559 0.725048 5.16933 0.725048 5.18544C0.725048 6.97389 1.99791 8.46695 3.68701 8.80531C3.37819 8.88856 3.05057 8.93421 2.7149 8.93421C2.47591 8.93421 2.24497 8.91004 2.01939 8.86707C2.48933 10.3333 3.8535 11.4021 5.4674 11.4316C4.2026 12.4225 2.61286 13.0133 0.8808 13.0133C0.582724 13.0133 0.290019 12.9945 0 12.9623C1.6327 14.0095 3.57422 14.6218 5.66075 14.6218C12.452 14.6218 16.1659 8.99597 16.1659 4.11666C16.1659 3.95554 16.1632 3.79711 16.1552 3.63867C16.8775 3.11771 17.5032 2.46785 17.9973 1.72669L18 1.73206Z",
    fill: "#41ABE1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.e564eef5.svg";
export { ForwardRef as ReactComponent };